import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mq } from '../../../styles/mixins';
import { THEME } from 'common/consts/theme';
import { ParagraphM, ParagraphXs } from '../../core/Typography/Typography';

export const ReviewCardWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 35.5625rem;
  min-height: 19.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 3.5rem 2rem 2rem 2rem;
  background: ${({ theme }) => theme.colors.core_white};
  border-radius: 0.5rem;
  margin-bottom: 4rem;

  ${mq.xLarge(css`
    min-height: 26.5rem;
    padding: 3.5rem 2rem 2rem 2rem;
    margin-bottom: 3.5rem;
  `)};
`;

export const QuoteText = styled.p`
  ${ParagraphM};
  color: ${({ theme }) => theme.colors.core_black};
  letter-spacing: 0.0125rem;
  margin: 1rem 0 0 0;

  ${mq.xLarge(css`
    margin-top: 2rem;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2.25rem;
  `)};
`;

export const Person = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: auto;
`;

export const PersonImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 3rem;
  max-width: 3rem;

  ${mq.xLarge(css`
    max-width: 5rem;
    max-height: 5rem;
    height: 5rem;
    width: 5rem;
  `)};

  .person-image {
    object-fit: contain;
  }
`;

export const PersonData = styled.div`
  font-weight: 400;
  margin: 0 0 0 0.75rem;

  ${mq.xLarge(css`
    margin-left: 2rem;
  `)};
`;

export const PersonName = styled.span`
  ${ParagraphM};
  display: block;
  font-family: ${({ theme }) => theme.font.questrial};
  color: ${({ theme }) => theme.colors.core_black};
`;

export const PersonCompanyPosition = styled.span`
  ${ParagraphXs};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};

  ${mq.xLarge(css`
    color: ${THEME.colors.black};
  `)};
`;
